import React, { useState } from 'react';

const WA_NUMBER = '201008182425';

// ── PASSAGES (shared across reading questions) ──────────────────────────────
const PASSAGES = {
  ra1: {
    label: 'Reading Passage – A1',
    text: 'My name is Sara. I am 25 years old and I live in Cairo, Egypt. I have one brother and one sister. Every day, I go to work by bus. In the evenings, I like to cook and watch films.',
  },
  ra2: {
    label: 'Reading Passage – A2',
    text: 'Last weekend, Tom went to the beach with his family. They left home early in the morning and drove for two hours to get there. The weather was warm and sunny. They swam in the sea and ate lunch at a small restaurant near the water. It was a wonderful day.',
  },
  rb1: {
    label: 'Reading Passage – B1',
    text: 'Social media has transformed the way people communicate worldwide. Many individuals now use platforms such as Instagram and Twitter to share their daily experiences. While these tools allow people to connect with others across the globe, research suggests they can also lead to feelings of loneliness and anxiety. Studies indicate that heavy social media use is linked to lower self-esteem, particularly among teenagers.',
  },
  rb2: {
    label: 'Reading Passage – B2',
    text: 'Remote work, once considered a privilege for a select few, has become mainstream for millions worldwide. The COVID-19 pandemic accelerated this shift dramatically, forcing companies to adapt almost overnight. While many employees report higher productivity and improved work-life balance, employers express concerns about team cohesion and performance monitoring. Policymakers are now addressing questions about labour rights and taxation in an era when the traditional office may no longer be central to working life.',
  },
  rc1: {
    label: 'Reading Passage – C1',
    text: 'The concept of "nudge theory", popularised by Thaler and Sunstein, posits that subtle changes in how choices are presented can significantly influence decision-making without restricting freedom. Governments have adopted behavioural insights to design public policy — from placing healthier foods at eye level in school canteens to automatically enrolling employees in pension schemes. Critics argue that such interventions are inherently paternalistic, assuming that authorities know better than individuals what constitutes beneficial behaviour.',
  },
};

// ── QUESTIONS (40 total) ────────────────────────────────────────────────────
const QUESTIONS = [
  // ── GRAMMAR A1 (1-3) ──────────────────────────────────────────────────────
  { section:'grammar', level:'A1',
    q:'Choose the correct sentence.',
    opts:['She have a cat.','She has a cat.','She is have a cat.','She having a cat.'], answer:1 },
  { section:'grammar', level:'A1',
    q:'Complete: "I ___ to school every day."',
    opts:['go','goes','going','am go'], answer:0 },
  { section:'grammar', level:'A1',
    q:'Which sentence is correct?',
    opts:["He don't like coffee.","He doesn't likes coffee.","He doesn't like coffee.","He not like coffee."], answer:2 },

  // ── GRAMMAR A2 (4-6) ──────────────────────────────────────────────────────
  { section:'grammar', level:'A2',
    q:'Complete: "She ___ TV when I called her."',
    opts:['watched','is watching','was watching','has watched'], answer:2 },
  { section:'grammar', level:'A2',
    q:'Choose the correct question: "How long ___ you known him?"',
    opts:['do','did','have','had'], answer:2 },
  { section:'grammar', level:'A2',
    q:'Complete: "I ___ never been to Paris."',
    opts:['have','had','did','do'], answer:0 },

  // ── GRAMMAR B1 (7-9) ──────────────────────────────────────────────────────
  { section:'grammar', level:'B1',
    q:'Complete: "By the time she arrived, we ___ waiting for an hour."',
    opts:['have been','had been','were','are'], answer:1 },
  { section:'grammar', level:'B1',
    q:'Which sentence uses the passive correctly?',
    opts:['The letter was writing by Tom.','The letter wrote by Tom.','The letter was written by Tom.','The letter has write by Tom.'], answer:2 },
  { section:'grammar', level:'B1',
    q:'Choose the correct conditional: "If I ___ more money, I would travel the world."',
    opts:['have','had','will have','would have'], answer:1 },

  // ── GRAMMAR B2 (10-12) ────────────────────────────────────────────────────
  { section:'grammar', level:'B2',
    q:'Complete: "Had I known about the meeting, I ___ attended."',
    opts:['would','will have','would have','had'], answer:2 },
  { section:'grammar', level:'B2',
    q:'Choose the correct sentence.',
    opts:['Despite of the rain, we went out.','Despite the rain, we went out.','In spite the rain, we went out.','Although the rain, we went out.'], answer:1 },
  { section:'grammar', level:'B2',
    q:'Complete: "The report ___ by the committee before the deadline."',
    opts:['will be submitted','will submit','submits','submitted'], answer:0 },

  // ── GRAMMAR C1 (13-15) ────────────────────────────────────────────────────
  { section:'grammar', level:'C1',
    q:'Which sentence demonstrates correct use of the subjunctive?',
    opts:['It is essential that he attends the meeting.','It is essential that he attend the meeting.','It is essential that he attended the meeting.','It is essential that he attending the meeting.'], answer:1 },
  { section:'grammar', level:'C1',
    q:'Complete: "Not only ___ the project succeed, but it also exceeded expectations."',
    opts:['did','had','was','has'], answer:0 },
  { section:'grammar', level:'C1',
    q:'Identify the correctly punctuated sentence.',
    opts:['The study which was conducted in 2020 found significant results.','The study, which was conducted in 2020, found significant results.','The study, which was conducted in 2020 found significant results.','The study which was conducted in 2020, found significant results.'], answer:1 },

  // ── VOCABULARY A1 (16-17) ─────────────────────────────────────────────────
  { section:'vocabulary', level:'A1',
    q:'What does "expensive" mean?',
    opts:['cheap','costs a lot of money','free','small'], answer:1 },
  { section:'vocabulary', level:'A1',
    q:'What is the opposite of "happy"?',
    opts:['sad','tall','fast','clean'], answer:0 },

  // ── VOCABULARY A2 (18-19) ─────────────────────────────────────────────────
  { section:'vocabulary', level:'A2',
    q:'Which word means "to start"?',
    opts:['finish','begin','complete','stop'], answer:1 },
  { section:'vocabulary', level:'A2',
    q:'What does "however" indicate?',
    opts:['addition','contrast','cause','result'], answer:1 },

  // ── VOCABULARY B1 (20-21) ─────────────────────────────────────────────────
  { section:'vocabulary', level:'B1',
    q:'What does "consequently" mean?',
    opts:['however','in addition','as a result','for example'], answer:2 },
  { section:'vocabulary', level:'B1',
    q:'Choose the word that means "to make something better".',
    opts:['improve','ignore','reduce','complicate'], answer:0 },

  // ── VOCABULARY B2 (22-23) ─────────────────────────────────────────────────
  { section:'vocabulary', level:'B2',
    q:'What does "ubiquitous" mean?',
    opts:['rare','found everywhere','expensive','complicated'], answer:1 },
  { section:'vocabulary', level:'B2',
    q:'Which phrase correctly uses "account for"?',
    opts:['Renewables account for 30% of energy.','Renewables account 30% for energy.','Renewables are accounted 30% of energy.','Renewables account for in 30% energy.'], answer:0 },

  // ── VOCABULARY C1 (24-25) ─────────────────────────────────────────────────
  { section:'vocabulary', level:'C1',
    q:'Choose the most precise academic word for "to lessen the impact of".',
    opts:['stop','mitigate','prevent','avoid'], answer:1 },
  { section:'vocabulary', level:'C1',
    q:'What does "corroborate" mean?',
    opts:['contradict','confirm with additional evidence','summarise','elaborate'], answer:1 },

  // ── READING A1 (26-27) ────────────────────────────────────────────────────
  { section:'reading', level:'A1', passageId:'ra1',
    q:'Where does Sara live?',
    opts:['London','Cairo','Paris','Dubai'], answer:1 },
  { section:'reading', level:'A1', passageId:'ra1',
    q:'How does Sara get to work?',
    opts:['By car','By train','By bus','On foot'], answer:2 },

  // ── READING A2 (28-29) ────────────────────────────────────────────────────
  { section:'reading', level:'A2', passageId:'ra2',
    q:"How long did it take Tom's family to drive to the beach?",
    opts:['One hour','Two hours','Three hours','Half an hour'], answer:1 },
  { section:'reading', level:'A2', passageId:'ra2',
    q:"What did Tom's family do after swimming?",
    opts:['They drove home','They went shopping','They ate lunch at a restaurant','They stayed at a hotel'], answer:2 },

  // ── READING B1 (30-31) ────────────────────────────────────────────────────
  { section:'reading', level:'B1', passageId:'rb1',
    q:'According to the passage, what is one negative effect of social media?',
    opts:['It connects people globally','It leads to loneliness and anxiety','It improves self-esteem','It reduces communication costs'], answer:1 },
  { section:'reading', level:'B1', passageId:'rb1',
    q:'Which group is most affected by heavy social media use, according to studies?',
    opts:['Adults','Young children','Teenagers','Elderly people'], answer:2 },

  // ── READING B2 (32-33) ────────────────────────────────────────────────────
  { section:'reading', level:'B2', passageId:'rb2',
    q:'What accelerated the widespread adoption of remote work?',
    opts:['Rapid technological advances','The COVID-19 pandemic','New government policy','Global economic recession'], answer:1 },
  { section:'reading', level:'B2', passageId:'rb2',
    q:'Which concern do employers raise about remote work?',
    opts:['Higher productivity levels','Employee satisfaction','Team cohesion','Reduced operational costs'], answer:2 },

  // ── READING C1 (34-35) ────────────────────────────────────────────────────
  { section:'reading', level:'C1', passageId:'rc1',
    q:'What does nudge theory primarily aim to do?',
    opts:["Restrict people's choices","Influence decisions without limiting freedom","Penalise poor decision-making","Educate individuals through formal training"], answer:1 },
  { section:'reading', level:'C1', passageId:'rc1',
    q:'According to critics, why is nudge theory problematic?',
    opts:['It is too expensive to implement','It has no scientific basis','It is paternalistic','It restricts freedom of choice directly'], answer:2 },

  // ── LISTENING (36-40) ─────────────────────────────────────────────────────
  { section:'listening', level:'A1',
    transcript:"Hello! My name is David. I work in a hospital as a doctor. I start work at eight o'clock in the morning and I finish at six in the evening. I live close to my workplace, so I usually walk. I really enjoy helping patients every day.",
    q:'What time does David start work?',
    opts:["Seven o'clock","Eight o'clock","Nine o'clock","Six o'clock"], answer:1 },
  { section:'listening', level:'A2',
    transcript:'Good morning, passengers. This is an announcement for flight EK204 to London Heathrow. Due to a technical issue, the flight will now depart at 14:30 instead of the scheduled time of 13:00. Passengers are kindly requested to remain in the departure lounge. We apologise for any inconvenience caused.',
    q:'How long is the flight delay?',
    opts:['30 minutes','1 hour','1 hour 30 minutes','2 hours'], answer:2 },
  { section:'listening', level:'B1',
    transcript:"Interviewer: So, Maria, why did you decide to study environmental science? Maria: Honestly, it started when I was a teenager. I read a book about climate change and it really opened my eyes to how serious the problem was. I knew then that I wanted to do something meaningful. Now I work with a research team studying how rising sea temperatures affect coral reefs, and I find it incredibly rewarding.",
    q:'What is Maria currently researching?',
    opts:['Rainforest deforestation','Air pollution in cities','The effect of rising sea temperatures on coral reefs','Melting Arctic ice'], answer:2 },
  { section:'listening', level:'B2',
    transcript:'...and while the economic argument for renewable energy is compelling — costs have fallen by nearly 90% over the last decade — the transition is not without challenges. Grid stability remains a critical concern, as solar and wind energy are inherently intermittent. Battery storage technology is advancing, but not yet at the scale needed to compensate for periods of low generation. Some analysts suggest that natural gas must serve as a bridging fuel during this transition.',
    q:'What does the speaker identify as a key challenge in the energy transition?',
    opts:['High installation costs','Lack of public support','Grid stability due to intermittent supply','Shortage of qualified engineers'], answer:2 },
  { section:'listening', level:'C1',
    transcript:'The notion that economic growth and environmental sustainability are fundamentally incompatible has been challenged by proponents of the green economy model. They argue that innovation in clean technology and circular manufacturing can decouple GDP growth from environmental degradation. Empirical evidence, however, is mixed. Some northern European nations have demonstrated relative decoupling, while many emerging economies continue to rely on carbon-intensive industries. The central question is not whether decoupling is theoretically possible, but whether it can occur fast enough to prevent the worst consequences of climate change.',
    q:'What does "decoupling" refer to in this context?',
    opts:['Reducing trade agreements between nations','Separating economic growth from environmental damage','Transitioning from fossil fuels to nuclear energy','Reducing government environmental spending'], answer:1 },
];

// ── SCORING (40 questions) ─────────────────────────────────────────────────
const LEVEL_MAP = [
  { min:0,  max:8,  cefr:'A1', label:'Beginner',           ielts:'no'    },
  { min:9,  max:14, cefr:'A2', label:'Pre-Intermediate',   ielts:'no'    },
  { min:15, max:21, cefr:'B1', label:'Intermediate',       ielts:'maybe' },
  { min:22, max:28, cefr:'B2', label:'Upper-Intermediate', ielts:'yes'   },
  { min:29, max:35, cefr:'C1', label:'Advanced',           ielts:'yes'   },
  { min:36, max:40, cefr:'C2', label:'Proficiency',        ielts:'yes'   },
];

const CEFR_DESC = {
  A1: 'You are at the beginner stage. You can understand and use basic phrases and introduce yourself. A solid foundation in General English will unlock rapid progress.',
  A2: 'You have elementary English skills. You can handle simple, routine tasks and familiar topics. A Pre-Intermediate course will build the grammar and vocabulary you need to advance.',
  B1: 'You are at the intermediate level. You can deal with most situations and produce connected text on familiar topics. Continue developing accuracy in an Intermediate course.',
  B2: 'You have upper-intermediate English. You can interact with a degree of fluency and produce clear, detailed text. You are IELTS-ready.',
  C1: 'You have advanced English proficiency. You can express ideas fluently and spontaneously. IELTS Preparation will sharpen your academic writing and listening strategies for a top band score.',
  C2: 'You have achieved proficiency-level English. Your language skills are highly sophisticated and precise. IELTS Preparation will be a targeted sprint to maximise your band score.',
};

const IELTS_MSG = {
  no:    null,
  maybe: 'You may qualify for IELTS preparation. Mr. Ahmed accepts motivated B1 students who are committed to working hard.',
  yes:   'You are ready for IELTS preparation with Mr. Ahmed Salem.',
};

const COURSE_NAME = {
  A1:'A1 Beginner', A2:'A2 Pre-Intermediate', B1:'B1 Intermediate',
  B2:'IELTS Preparation', C1:'IELTS Preparation', C2:'IELTS Preparation',
};

const WA_IELTS = '201008182425';
const IELTS_PACKAGES_PT = [
  {
    name:'Standard', price:'500 AED', color:'#1a5fa8', bg:'#e8f0fb',
    note:'1 round · 6 weeks · All 4 skills',
    waMsg:'Hello Mr. Ahmed Salem! I just completed the IELTS Compass Placement Test and I am interested in the IELTS Standard Package (500 AED). Please contact me with enrolment details.',
  },
  {
    name:'Premium', price:'800 AED', color:'#b8860b', bg:'#fffaf0',
    note:'Unlimited rounds · Was 1800 AED',
    badge:'Best Value',
    waMsg:'Hello Mr. Ahmed Salem! I just completed the IELTS Compass Placement Test and I am interested in the IELTS Premium Package (800 AED — unlimited rounds). Please contact me with enrolment details.',
  },
];

const SECTION_META = {
  grammar:    { icon:'📝', label:'Grammar' },
  vocabulary: { icon:'📖', label:'Vocabulary' },
  reading:    { icon:'📄', label:'Reading Comprehension' },
  listening:  { icon:'🎧', label:'Listening Comprehension' },
};

// ── STYLES ─────────────────────────────────────────────────────────────────
const s = {
  wrap:  { minHeight:'100vh', background:'linear-gradient(135deg,#f0f4f8 0%,#e4ecf7 100%)', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'flex-start', padding:'28px 16px' },
  card:  { width:'100%', maxWidth:640, background:'#fff', border:'1px solid #dde3ed', borderRadius:14, padding:28, boxShadow:'0 4px 24px rgba(26,42,74,0.10)', marginBottom:20 },
  h1:    { fontFamily:"'Cormorant Garamond',serif", fontSize:24, fontWeight:700, color:'#1a2a4a', marginBottom:6 },
  sub:   { fontSize:13, color:'#5a6a88', lineHeight:1.6, marginBottom:22 },
  prog:  { height:6, borderRadius:3, background:'#e4ecf7', marginBottom:16, overflow:'hidden' },
  bar:   (pct) => ({ height:'100%', width:`${pct}%`, background:'linear-gradient(90deg,#b8860b,#d4a017)', borderRadius:3, transition:'width .35s' }),
  shead: { display:'flex', alignItems:'center', gap:8, marginBottom:12, padding:'8px 12px', background:'#f7f9fc', border:'1px solid #e4ecf7', borderRadius:8 },
  slbl:  { fontSize:11.5, fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.13em', textTransform:'uppercase', color:'#5a6a88' },
  qtext: { fontSize:15.5, fontWeight:600, color:'#1a2233', marginBottom:18, lineHeight:1.55 },
  passageBox: { background:'#f7f9fc', border:'1.5px solid #dde3ed', borderRadius:9, padding:'14px 16px', marginBottom:16 },
  passageLbl: { fontSize:10.5, fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.14em', textTransform:'uppercase', color:'#9aa3b8', marginBottom:7 },
  passageTxt: { fontSize:13.5, color:'#2a3a5a', lineHeight:1.75 },
  transcriptBox: { background:'#f0f6ff', border:'1.5px solid #c0d8f8', borderRadius:9, padding:'14px 16px', marginBottom:16 },
  transcriptLbl: { fontSize:10.5, fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.14em', textTransform:'uppercase', color:'#3a6aaa', marginBottom:7 },
  transcriptTxt: { fontSize:13, color:'#1a3a5a', lineHeight:1.8, fontStyle:'italic' },
  opt:   (state) => ({
    display:'flex', alignItems:'center', gap:12, padding:'12px 16px', borderRadius:9, marginBottom:9, cursor:state==='unanswered'?'pointer':'default',
    border:`1.5px solid ${state==='correct'?'#27ae60':state==='wrong'?'#e74c3c':'#dde3ed'}`,
    background:state==='correct'?'#f0faf4':state==='wrong'?'#fff5f5':'#f7f9fc',
    transition:'all .15s',
  }),
  optTxt:(state) => ({ fontSize:13.5, color:state==='correct'?'#1a6a3a':state==='wrong'?'#9a2010':'#1a2233', fontWeight:state!=='unanswered'?600:400 }),
  btn:   { width:'100%', background:'linear-gradient(135deg,#1a2a4a,#2a3a6a)', color:'#fff', border:'none', padding:13, borderRadius:8, fontSize:14, fontWeight:600, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif", boxShadow:'0 2px 8px rgba(26,42,74,0.25)', marginTop:8 },
  wabtn: { width:'100%', background:'#25d366', color:'#fff', border:'none', padding:14, borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif", boxShadow:'0 2px 10px rgba(37,211,102,0.35)', display:'flex', alignItems:'center', justifyContent:'center', gap:10, marginBottom:12 },
  back:  { background:'none', border:'none', color:'#9aa3b8', fontSize:11, cursor:'pointer', fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.08em' },
};

function WAIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );
}

function optState(chosen, correctAnswer, optIdx, answered) {
  if (!answered) return 'unanswered';
  if (optIdx === correctAnswer) return 'correct';
  if (optIdx === chosen) return 'wrong';
  return 'unanswered';
}

export default function PlacementTest({ onBack }) {
  const [phase,  setPhase]  = useState('intro');
  const [idx,    setIdx]    = useState(0);
  const [score,  setScore]  = useState(0);
  const [chosen, setChosen] = useState(null);
  const [result, setResult] = useState(null);

  const q       = QUESTIONS[idx];
  const section = SECTION_META[q?.section] || {};
  const passage = q?.passageId ? PASSAGES[q.passageId] : null;
  const prevSection = idx > 0 ? QUESTIONS[idx - 1].section : null;
  const sectionChanged = q?.section !== prevSection;
  const pct = (idx / QUESTIONS.length) * 100;

  function pick(i) {
    if (chosen !== null) return;
    setChosen(i);
  }

  function next() {
    const correct = chosen === q.answer;
    const newScore = score + (correct ? 1 : 0);

    if (idx < QUESTIONS.length - 1) {
      setScore(newScore);
      setIdx(idx + 1);
      setChosen(null);
    } else {
      const lvl = LEVEL_MAP.find(l => newScore >= l.min && newScore <= l.max) || LEVEL_MAP[0];
      setScore(newScore);
      setResult(lvl);
      setPhase('result');
    }
  }

  function restart() {
    setPhase('intro'); setIdx(0); setScore(0); setChosen(null); setResult(null);
  }

  function openWA(lvl) {
    let msg;
    if (lvl.ielts === 'maybe') {
      msg = `Hello Mr. Ahmed Salem! I completed the IELTS Compass Placement Test and scored ${score}/40, placing me at B1 (Intermediate). I understand I may qualify for IELTS preparation. I am motivated and committed to working hard. Please contact me to discuss enrolment options.`;
    } else if (lvl.ielts === 'yes') {
      msg = `Hello Mr. Ahmed Salem! I completed the IELTS Compass Placement Test and scored ${score}/40, placing me at ${lvl.cefr} (${lvl.label}). I am ready for IELTS Preparation. Please contact me to enrol.`;
    } else {
      msg = `Hello Mr. Ahmed Salem! I completed the IELTS Compass Placement Test and scored ${score}/40, placing me at ${lvl.cefr} (${lvl.label}). I would like to enrol in the ${COURSE_NAME[lvl.cefr]} course. Please contact me with details.`;
    }
    window.open(`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`, '_blank');
  }

  // ── INTRO ────────────────────────────────────────────────────────────────
  if (phase === 'intro') return (
    <div style={s.wrap}>
      <div style={{ width:'100%', maxWidth:640 }}>
        <button onClick={onBack} style={{ ...s.back, marginBottom:16 }}>← Back</button>
        <div className="fade-up" style={s.card}>
          <div style={s.h1}>English Level Placement Test</div>
          <div style={s.sub}>
            40 questions · Grammar, Vocabulary, Reading &amp; Listening · A1 to C2<br/>
            This test identifies your current level and recommends the right course. Questions become progressively more challenging.
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:22 }}>
            {[
              ['40','Questions'],
              ['A1–C2','All CEFR Levels'],
              ['4','Skill Sections'],
              ['Free','No login needed'],
            ].map(([v, l]) => (
              <div key={l} style={{ background:'#f7f9fc', border:'1px solid #dde3ed', borderRadius:9, padding:'12px 14px' }}>
                <div style={{ fontSize:20, fontWeight:700, color:'#b8860b', fontFamily:"'Cormorant Garamond',serif" }}>{v}</div>
                <div style={{ fontSize:11.5, color:'#5a6a88' }}>{l}</div>
              </div>
            ))}
          </div>
          <div style={{ background:'#f7f9fc', border:'1px solid #dde3ed', borderRadius:9, padding:'12px 16px', marginBottom:20 }}>
            {[
              ['📝','Grammar','15 questions'],
              ['📖','Vocabulary','10 questions'],
              ['📄','Reading Comprehension','10 questions (5 passages)'],
              ['🎧','Listening Comprehension','5 questions (written transcripts)'],
            ].map(([icon, name, count]) => (
              <div key={name} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'5px 0', borderBottom:'1px solid #edf0f5' }}>
                <span style={{ fontSize:13, color:'#2a3a5a' }}>{icon} {name}</span>
                <span style={{ fontSize:11.5, color:'#9aa3b8', fontFamily:"'JetBrains Mono',monospace" }}>{count}</span>
              </div>
            ))}
          </div>
          <button onClick={() => setPhase('test')} style={s.btn}>Start Placement Test →</button>
        </div>
      </div>
    </div>
  );

  // ── TEST ─────────────────────────────────────────────────────────────────
  if (phase === 'test') return (
    <div style={s.wrap}>
      <div style={{ width:'100%', maxWidth:640 }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 }}>
          <button onClick={onBack} style={s.back}>← Exit</button>
          <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11, color:'#9aa3b8' }}>Question {idx + 1} / {QUESTIONS.length}</div>
        </div>

        <div style={s.prog}><div style={s.bar(pct)}/></div>

        <div className="fade-up" style={s.card}>
          {/* Section header */}
          <div style={s.shead}>
            <span style={{ fontSize:16 }}>{section.icon}</span>
            <span style={s.slbl}>{section.label}</span>
            <span style={{ marginLeft:'auto', fontSize:11, color:'#9aa3b8', fontFamily:"'JetBrains Mono',monospace" }}>Level: {q.level}</span>
          </div>

          {/* Passage (reading) */}
          {passage && (
            <div style={s.passageBox}>
              <div style={s.passageLbl}>{passage.label}</div>
              <div style={s.passageTxt}>{passage.text}</div>
            </div>
          )}

          {/* Transcript (listening) */}
          {q.transcript && (
            <div style={s.transcriptBox}>
              <div style={s.transcriptLbl}>🎧 Listening Comprehension – Read the transcript and answer the question</div>
              <div style={s.transcriptTxt}>{q.transcript}</div>
            </div>
          )}

          {/* Question */}
          <div style={s.qtext}>{idx + 1}. {q.q}</div>

          {/* Options */}
          {q.opts.map((opt, i) => {
            const state = optState(chosen, q.answer, i, chosen !== null);
            return (
              <div key={i} style={s.opt(state)} onClick={() => pick(i)}>
                <div style={{
                  width:24, height:24, borderRadius:'50%', border:'1.5px solid #c8d0e0', display:'flex', alignItems:'center', justifyContent:'center',
                  fontSize:12, color:'#9aa3b8', flexShrink:0,
                  background: state==='correct'?'#27ae60': state==='wrong'?'#e74c3c':'#f7f9fc',
                  color: state!=='unanswered'?'#fff':'#9aa3b8',
                }}>
                  {state==='correct'?'✓': state==='wrong'?'✗': String.fromCharCode(65+i)}
                </div>
                <span style={s.optTxt(state)}>{opt}</span>
              </div>
            );
          })}

          {chosen !== null && (
            <button onClick={next} style={{ ...s.btn, marginTop:14 }}>
              {idx < QUESTIONS.length - 1 ? 'Next Question →' : 'See My Results →'}
            </button>
          )}
        </div>
      </div>
    </div>
  );

  // ── RESULT ───────────────────────────────────────────────────────────────
  if (phase === 'result' && result) {
    const ieltsMsg = IELTS_MSG[result.ielts];
    return (
      <div style={s.wrap}>
        <div style={{ width:'100%', maxWidth:640 }}>
          <div className="fade-up" style={s.card}>
            <div style={{ textAlign:'center', marginBottom:20 }}>
              <div style={{ fontSize:60, fontFamily:"'Cormorant Garamond',serif", fontWeight:700, color:'#b8860b', lineHeight:1.1 }}>{result.cefr}</div>
              <div style={{ fontSize:18, fontWeight:700, color:'#1a2a4a', marginBottom:4 }}>{result.label}</div>
              <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11, color:'#9aa3b8', letterSpacing:'.12em' }}>Score: {score} / 40</div>
            </div>

            <div style={{ background:'#f0f4f8', borderRadius:8, height:10, marginBottom:18, overflow:'hidden' }}>
              <div style={{ height:'100%', width:`${(score/40)*100}%`, background:'linear-gradient(90deg,#b8860b,#d4a017)', borderRadius:8, transition:'width 1s' }}/>
            </div>

            <div style={{ background:'#f7f9fc', border:'1px solid #dde3ed', borderRadius:9, padding:'14px 16px', marginBottom:16 }}>
              <div style={{ fontSize:13.5, color:'#2a3a5a', lineHeight:1.7 }}>{CEFR_DESC[result.cefr]}</div>
            </div>

            {/* IELTS eligibility */}
            {ieltsMsg && (
              <div style={{
                background: result.ielts==='maybe'?'#fff8e8':'linear-gradient(135deg,#1a2a4a,#2a3a6a)',
                border: `1px solid ${result.ielts==='maybe'?'#f0d060':'#2a3a6a'}`,
                borderRadius:9, padding:'16px 18px', marginBottom:16,
              }}>
                <div style={{ fontSize:11, fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.13em', textTransform:'uppercase', color:result.ielts==='maybe'?'#9a7000':'#9ab4d4', marginBottom:6 }}>
                  {result.ielts==='maybe' ? 'IELTS Eligibility' : 'Recommended Course'}
                </div>
                <div style={{ fontSize:result.ielts==='yes'?17:15, fontWeight:700, color:result.ielts==='maybe'?'#7a5000':'#fff', marginBottom:result.ielts==='yes'?4:0 }}>
                  {result.ielts==='yes' && 'IELTS Preparation'}
                </div>
                <div style={{ fontSize:13.5, color:result.ielts==='maybe'?'#5a3800':'#c8d8f0', lineHeight:1.6 }}>{ieltsMsg}</div>
              </div>
            )}

            {/* General English recommendation for A1/A2 */}
            {!ieltsMsg && (
              <div style={{ background:'#f0faf4', border:'1px solid #c8ead8', borderRadius:9, padding:'16px 18px', marginBottom:16 }}>
                <div style={{ fontSize:11, fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.13em', textTransform:'uppercase', color:'#1a6a3a', marginBottom:6 }}>Recommended Course</div>
                <div style={{ fontSize:17, fontWeight:700, color:'#1a3a2a', marginBottom:4 }}>{COURSE_NAME[result.cefr]}</div>
                <div style={{ fontSize:13, color:'#2a5a3a', lineHeight:1.55 }}>
                  A {COURSE_NAME[result.cefr]} course will give you the grammar accuracy, vocabulary range, and speaking confidence to advance to the next level.
                </div>
              </div>
            )}

            {/* IELTS package cards for eligible levels */}
            {result.ielts !== 'no' && (
              <div style={{ marginBottom:16 }}>
                <div style={{ fontSize:12, fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.12em', textTransform:'uppercase', color:'#9aa3b8', marginBottom:10 }}>IELTS Preparation Packages</div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                  {IELTS_PACKAGES_PT.map(pkg => (
                    <div key={pkg.name} style={{ background:pkg.bg, border:`1.5px solid ${pkg.color}44`, borderRadius:10, padding:'14px 14px' }}>
                      {pkg.badge && (
                        <div style={{ fontSize:10, fontWeight:700, color:pkg.color, background:`${pkg.color}22`, border:`1px solid ${pkg.color}44`, borderRadius:100, padding:'1px 8px', display:'inline-block', marginBottom:6, fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.08em' }}>{pkg.badge}</div>
                      )}
                      <div style={{ fontSize:13, fontWeight:700, color:'#1a2a4a', marginBottom:2 }}>{pkg.name}</div>
                      <div style={{ fontSize:22, fontWeight:700, color:pkg.color, fontFamily:"'Cormorant Garamond',serif", lineHeight:1.1, marginBottom:4 }}>{pkg.price}</div>
                      <div style={{ fontSize:11, color:'#5a6a88', marginBottom:10 }}>{pkg.note}</div>
                      <button onClick={() => window.open(`https://wa.me/${WA_IELTS}?text=${encodeURIComponent(pkg.waMsg)}`, '_blank')}
                        style={{ width:'100%', background:'#25d366', color:'#fff', border:'none', padding:'8px 0', borderRadius:7, fontSize:12.5, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
                        <WAIcon size={13}/> Enquire
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <button onClick={() => openWA(result)} style={s.wabtn}>
              <WAIcon/>
              Contact Mr. Ahmed to Enrol
            </button>

            <div style={{ display:'flex', gap:10 }}>
              <button onClick={restart} style={{ flex:1, background:'#f7f9fc', border:'1.5px solid #dde3ed', color:'#1a2233', padding:11, borderRadius:8, fontSize:13, fontWeight:500, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Retake Test</button>
              <button onClick={onBack}  style={{ flex:1, background:'#f7f9fc', border:'1.5px solid #dde3ed', color:'#1a2233', padding:11, borderRadius:8, fontSize:13, fontWeight:500, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>← Back</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
